import { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useMutation, useLazyQuery } from '@apollo/client'
import { Tab } from 'react-bootstrap'

import { useAppDispatch, useAppSelector } from 'hooks/store'
import {
  getEmptyDocumentProcessing,
  setDocumentProcessing,
  setSelectedDocumentId,
  setSelectedDocument,
  setTabReview,
  setTabSubmit
} from 'reducers/document/documentProcessingSlice'
import { DocumentCategory } from 'share/domain/document'
import GoBackHeader from 'components/organisms/GoBackHeader'
import {
  GET_DOCUMENT_DASHBOARD,
  GetDocumentDashboardQueryResponse
} from 'share/queries/documents'
import { formatDate } from 'share/utils/utils'
import {
  SetOpenedDocResponse,
  SetOpenedDocVariables,
  SET_OPENED_DOC
} from 'share/mutations/documents'
import StyledTabs from 'components/molecules/StyledTabs'
import TemplateView from 'components/organisms/TemplateView'
import { loadingSpinnerPortal } from 'components/atoms/LoadingSpinner'

import './styles.scss'
import DocumentFolderList from 'components/organisms/DocumentFolderList'

interface IHistory {
  caseId?: number
}

const truncateFileName = (text: string) => {
  if (text.length > 20) {
    const start = text.substring(0, 14)
    const end = text.substring(text.length - 5)
    const newDocText = `${start}...${end}`
    return newDocText
  }

  return text
}

const Documents: FC = () => {
  const history = useHistory<IHistory>()
  const dispatch = useAppDispatch()
  const activeCase = useAppSelector((state) => state.activeCase)
  const [categories, setCategories] = useState<DocumentCategory[]>([])
  const documentProcessing = useAppSelector((state) => state.documentProcessing)
  const [key, setKey] = useState(() =>
    documentProcessing.activeTab === 'submit' ? 'submit' : 'review'
  )

  const [isLoading, setIsLoading] = useState(false)

  const [getDocumentDashboard, { loading, data, error }] =
    useLazyQuery<GetDocumentDashboardQueryResponse>(GET_DOCUMENT_DASHBOARD, {
      fetchPolicy: 'network-only'
    })

  const [setOpenedDoc] =
    useMutation<SetOpenedDocResponse, SetOpenedDocVariables>(SET_OPENED_DOC)

  useEffect(() => {
    if (activeCase) {
      if (activeCase.matter) {
        if (activeCase.matter.id && categories.length === 0) {
          getDocumentDashboard({ variables: { caseId: activeCase.matter.id } })
        }
      }
    }
  }, [activeCase])

  useEffect(() => {
    if (loading) {
      setIsLoading(true)
    } else {
      setIsLoading(false)
    }
    if (data && data?.documents.documentDashboard.submit.length > 0) {
      setCategories(data?.documents.documentDashboard.submit)
      // intialize the redux store to empty everytime we come to this page
      dispatch(setDocumentProcessing(getEmptyDocumentProcessing()))
      if (key === 'review') {
        dispatch(setTabReview())
      }
    }
  }, [data, loading])

  if (error) {
    return <div>{error?.message}</div>
  }

  function handleSelect(tabKey: string | null) {
    if (tabKey === key) return

    setKey(tabKey ? tabKey : 'submit')

    if (key === 'submit') {
      dispatch(setTabReview())
    } else {
      dispatch(setTabSubmit())
    }
  }

  return (
    <>
      <GoBackHeader text='Documents' />
      {isLoading && loadingSpinnerPortal()}
      <TemplateView title='Submit Requested Documents'>
        <StyledTabs
          defaultActiveKey='submit'
          id='ui-docs-tabs'
          onSelect={handleSelect}
          activeKey={key}
        >
          <Tab eventKey='submit' title='Submit'>
            <DocumentFolderList folders={categories} />
          </Tab>
          <Tab eventKey='review' title='Review'>
            <ul className='ui-review-docs mb-0'>
              {data &&
                data.documents?.documentDashboard.review.map((doc) => {
                  return (
                    <li
                      key={doc.id}
                      onClick={() => {
                        console.log('review docId')
                        console.dir(doc)
                        dispatch(setSelectedDocumentId(doc.id))
                        dispatch(setSelectedDocument(doc))
                        setOpenedDoc({
                          variables: { documentId: doc.id }
                        })
                          .then((res) => console.log(res))
                          .catch((err) => console.log(err))
                        history.push('/dashboard/documents/detail')
                      }}
                    >
                      <div className={`${!doc.opened ? 'unread' : 'read'}`}>
                        <p>{truncateFileName(doc.name)}</p>
                        {doc.comments.length > 0 && (
                          <span>
                            {doc.comments.length + ' '}
                            Comment{doc.comments.length > 1 ? 's' : ''}
                          </span>
                        )}
                      </div>
                      <span>{formatDate(doc.uploaded)}</span>
                    </li>
                  )
                })}
            </ul>
          </Tab>
        </StyledTabs>
      </TemplateView>
    </>
  )
}

export default Documents
